import { useLayoutEffect } from 'react';
import { useLocation, useNavigationType } from 'react-router-dom';

// Disable native scroll restoration once — we manage it ourselves.
if (typeof window !== 'undefined' && 'scrollRestoration' in window.history) {
  try {
    window.history.scrollRestoration = 'manual';
  } catch {
    // Non-fatal
  }
}

/**
 * Reset scroll to the top on forward navigation (PUSH / REPLACE) only.
 * On POP (browser/native back/forward) we leave the DOM untouched so the
 * page can mount without a visible jump or double-scroll flicker.
 */
export function ScrollToTop() {
  const { pathname } = useLocation();
  const navigationType = useNavigationType();

  useLayoutEffect(() => {
    if (navigationType === 'POP') return;

    window.scrollTo({ top: 0, left: 0, behavior: 'instant' as ScrollBehavior });
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;

    const mainContainer = document.getElementById('main-scroll');
    if (mainContainer) mainContainer.scrollTop = 0;
  }, [pathname, navigationType]);

  return null;
}
